import axios from "./axios";
import axios_rpt from "./axios_rpt";
import { server, other, repttown } from "./constants";
import store from "@/store";

// Variable
let cacheProducts, cacheStores;

// =======================
// =  Rounting Function  =
// =======================

let _routeAPI = {
    _loaded: false,
    loading: false,
    get loaded() {
        return this._loaded;
    },
    set loaded(v) {
        this._loaded = v;
        while (this.Listener.length)
            (this.Listener.pop())();
    },
    Listener: [],
    addListener: function (func) {
        this.Listener.push(func);
    }
}

let _routeRPTAPI = {
    _loaded: false,
    loading: false,
    get loaded() {
        return this._loaded;
    },
    set loaded(v) {
        this._loaded = v;
        while (this.Listener.length)
            (this.Listener.pop())();
    },
    Listener: [],
    addListener: function (func) {
        this.Listener.push(func);
    }
}

////////////////////////////////////////////////////////////////////////////// < SHOUD BE UPDATED >
/**
 * Get all route
 * @return {{animals?: [object], petfoods?: [object], supplies?: [object]}}
 */
const getRoute = async (query=null) => {
    // Not loaded yet but loading
    // let w = false;
    if (!_routeAPI.loaded && _routeAPI.loading) {
        // console.log('waiting..');
        // w = true;
        await new Promise(r => _routeAPI.addListener(r));
    }

    // Load from session storage
    let status, data = JSON.parse(sessionStorage.getItem(server.ROUTES_CACHE));
    // if (w) console.log('continue -> cache');
    // if (data) console.log('cache');
    if (data) return data;

    // Fetching from backend
    _routeAPI.loading = true;
    ({data, status} = await axios.get(other.ROUTE_URL, { params: query }));
    
    if (status == undefined || status == 500 || status == 503)
        makeAlert('Server is down.', 'secondary');

    if (data && data.animals)
        sessionStorage.setItem(server.ROUTES_CACHE, JSON.stringify(data));
    _routeAPI.loaded = true;
    return data;
}

/**
 * Get all ReptTown route
 * @return {{animals?: [object], petfoods?: [object], supplies?: [object]}}
 */
 const getRPTRoute = async () => {
    // Not loaded yet but loading
    // let w = false;
    if (!_routeRPTAPI.loaded && _routeRPTAPI.loading) {
        // console.log('waiting..');
        // w = true;
        await new Promise(r => _routeRPTAPI.addListener(r));
    }

    // Load from session storage
    let status, data = JSON.parse(sessionStorage.getItem(server.RPT_ROUTES_CACHE));
    // if (w) console.log('continue -> cache');
    // if (data) console.log('cache');
    if (data) return data;

    // Fetching from backend
    _routeRPTAPI.loading = true;
    ({data, status} = await axios_rpt.get(other.ROUTE_URL, { params: { nolog: true } }));

    if (status == undefined || status == 500 || status == 503)
        console.log('ReptTown is down');
        // makeAlert('Server is down.', 'secondary');

    if (data && data.animals)
        sessionStorage.setItem(server.RPT_ROUTES_CACHE, JSON.stringify(data));
    _routeRPTAPI.loaded = true;
    return data;
}
//////////////////////////////////////////////////////////////////////////////

/**
 * Get all product list / info,
 * url is same as $route.path
 *
 *      Example:
 *      Get Product List
 *      url = 'animals'
 *      url = 'animals/snakes'
 * 
 *      Get Product Info
 *      url = 'id/5f6...b75'
 * 
 * @param {String} url 
 * @param {Object} params 
 * @return {{data: any, status: Number}} status = HTTP Status Codes
 */
const getProducts = async (url, params=null) => {
    if (url == undefined) return {};

    // Check if user just view this product,
    // if so this will set addView to false
    // and not incrase view-counter on the product.
    if (url.indexOf('id') != -1) {
        // Check View Cache
        var addView = true;
        var productID = url.split('/')[1];
        var viewCache = sessionStorage.getItem(server.VIEW_PRODUCT_CACHE);
        if (viewCache) {
            viewCache = JSON.parse(viewCache);
            // If already cache
            if (viewCache[productID])
                addView = false;
            else {
                viewCache[productID] = true;
                sessionStorage.setItem(server.VIEW_PRODUCT_CACHE, JSON.stringify(viewCache));
            }
        } else {
            // First time for viewCache
            viewCache = {[productID]: true}
            sessionStorage.setItem(server.VIEW_PRODUCT_CACHE, JSON.stringify(viewCache));
        }
    }

    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(`${other.PRODUCT_URL}/${url}`, { 
        params: { ...params, view: addView },
        headers: { 'Authorization': `be ${accessToken}` }
    });

    // Return if NotFound
    if (!data || status != 200)
        return { data, status };

    // Calc Price on Products
    if ('products' in data) {
        // PRODUCT LIST
        data.products.forEach((product) => {
            if (product.cutoffPrice) {
                product.discountPrice = product.price;
                // Orinal Price
                product.price = product.price + product.cutoffPrice;
            }
        });
        cacheProducts = { url, params, data };
    } else {
        // PRODUCT INFO
        if (data.cutoffPrice) {
            data.discountPrice = data.price;
            // Orinal Price
            data.price = data.price + data.cutoffPrice;
        }
    }
    return { data, status };
}

/**
 * Get products by storeID
 * @param {String} id
 * @param {Object} params 
 * @returns {{storeName: String, product: {animals: [object], petfoods: [object], supplies: [object]}}}
 */
const getProductsByStore = async (id, params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data, status } = await axios.get(`${other.GET_PRODUCT_BY_STORE_URL}/${id}`, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });

    if (!data || status != 200) return data;

    if ('products' in data) {
        // PRODUCT LIST
        data.products.forEach((product) => {
            if (product.cutoffPrice) {
                product.discountPrice = product.price;
                // Orinal Price
                product.price = product.price + product.cutoffPrice;
            }
        });
    }
    return data;
}

const getStoreList = async (params) => {
    var { data, status } = await axios.get(other.GET_STORE_URL, {
        params,
    });
    if (data)
        cacheStores = { params, data };
    return data;
}

/**
 * Get Store Info
 * @param {String} id 
 * @returns 
 */
const getStoreInfo = async (id, params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(`${other.GET_STORE_URL}/id/${id}`, { 
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return { data, status };
}

/**
 * Make alert (with overlay component)
 * @param {String} message 
 * @param {String} color 
 * @param {Number} duration - in second 
 */
const makeAlert = (message, color, duration=null) => {
    if (duration) duration *= 1000;
    store.dispatch({ type: 'MakeAlert', msg: message, color, duration });
}

const getCacheProducts = (url, params=null) => {
    if (cacheProducts && cacheProducts.url == url && JSON.stringify(cacheProducts.params) == JSON.stringify(params))
        return cacheProducts.data;
}

const getCacheStores = (params=null) => {
    if (cacheStores && JSON.stringify(cacheStores.params) == JSON.stringify(params))
        return cacheStores.data;
    return null;
}

const postFeedback = async (message) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.post(`feedback`, { message }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

export default {
    getRoute,
    getProducts,
    getProductsByStore,
    getStoreList,
    getStoreInfo,
    makeAlert,
    postFeedback,

    getCacheProducts,
    getCacheStores,

    // ReptTown
    getRPTRoute,
}